import React from 'react'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import { ImageComp } from '../../../Components/ImageCompo/ImageComp'

const InitialMessage = () => {
    return (
        <>
            <div className='flex flex-col  h-[50vh] items-center'>
                <ParagraphComp className=' text-3xl font-bold text-[#d03737]' text={`Discover nonprofits by using the search field above and/or filters on the left.`} />
                <ImageComp source='./Images/Group 691314559.png' className='object-cover mt-[35px] h-[250px] w-auto' />
                {/* <ParagraphComp className='font-bold text-sm' text='Try shortening or rephrasing your search' /> */}
                {/* <ButtonComp onClick={openModal} className='px-[40px] py-[2px] text-[12px]  rounded-full bg-[#004878] text-[white]' text='Try Advanced Search' /> */}
            </div>
        </>
    )
}

export default InitialMessage